import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './MemberRightsPage.css';

const MemberRightsPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [order, setOrder] = useState(null);
    const [showRedeemModal, setShowRedeemModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [currentRight, setCurrentRight] = useState(null);
    const [selectedPlatform, setSelectedPlatform] = useState('');
    
    // 初始化权益数据
    const [rightsList, setRightsList] = useState([
        {
            id: 1,
            type: 'video',
            icon: '🎬',
            bgColor: '#e8f5e9',
            title: '视频VIP月卡',
            desc: '爱奇艺 / 腾讯 / 优酷 / 芒果 4选1',
            status: 'pending', // pending, redeemed
            platforms: ['爱奇艺', '腾讯视频', '优酷', '芒果TV']
        },
        {
            id: 2,
            type: 'coupon',
            icon: '🚗',
            bgColor: '#e3f2fd',
            title: '出行外卖通用券',
            desc: '高德/滴滴/美团/饿了么 满30减15',
            status: 'pending'
        },
        {
            id: 3,
            type: 'service',
            icon: '🧹',
            bgColor: '#fff3e0',
            title: '家政服务9折券',
            desc: '全平台通用，无门槛使用',
            status: 'redeemed', // 假设为了演示，这个已经自动发放
            redeemTime: '2025-08-29'
        }
    ]);

    useEffect(() => {
        // 从路由状态中获取订单信息，模拟真实场景
        if (location.state && location.state.order) {
            setOrder(location.state.order);
            // 实际上这里应该根据 order.serviceName 决定显示哪些权益
            // 为演示效果，保持默认 rightsList
        }
    }, [location]);

    const handleRedeemClick = (right) => {
        if (right.status === 'redeemed') return;
        setCurrentRight(right);
        setSelectedPlatform(''); // 重置选择
        setShowRedeemModal(true);
    };

    const confirmRedeem = () => {
        if (currentRight.type === 'video' && !selectedPlatform) {
            alert('请先选择一个平台');
            return;
        }

        // 模拟API调用
        setTimeout(() => {
            setShowRedeemModal(false);
            setShowSuccessModal(true);
            
            // 更新本地状态
            setRightsList(prev => prev.map(item => {
                if (item.id === currentRight.id) {
                    return { ...item, status: 'redeemed', redeemTime: new Date().toLocaleDateString() };
                }
                return item;
            }));
        }, 500);
    };

    return (
        <div className="rights-page">
            <header className="rights-header">
                <button className="back-btn" onClick={() => navigate(-1)}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M15 18l-6-6 6-6" />
                    </svg>
                </button>
                <h1>权益领取中心</h1>
                <div style={{width: 40}}></div>
            </header>

            <div className="rights-content">
                {/* 顶部卡片 */}
                <div className="member-card-banner">
                    <div className="mc-header">
                        <div className="mc-title">{order?.serviceName || '至尊联合会员'}</div>
                        <div className="mc-status">生效中</div>
                    </div>
                    <div className="mc-info">
                        <h3>当前周期剩余权益</h3>
                        <p>{rightsList.filter(r => r.status === 'pending').length} 项待领取</p>
                    </div>
                </div>

                {/* 权益列表 */}
                <div className="rights-section-title">本月待领权益</div>
                <div className="rights-grid">
                    {rightsList.map(right => (
                        <div key={right.id} className="right-item-card">
                            <div className="right-icon-box" style={{background: right.bgColor}}>
                                {right.icon}
                            </div>
                            <div className="right-info">
                                <h4>{right.title}</h4>
                                <p>{right.status === 'redeemed' ? `已领取 (${right.redeemTime})` : right.desc}</p>
                            </div>
                            <button 
                                className={`right-btn ${right.status === 'redeemed' ? 'btn-done' : 'btn-redeem'}`}
                                onClick={() => handleRedeemClick(right)}
                            >
                                {right.status === 'redeemed' ? '已领取' : '立即领取'}
                            </button>
                        </div>
                    ))}
                </div>
                
                <div style={{marginTop: 32, textAlign: 'center', color: '#999', fontSize: 12}}>
                    <p>权益每月1日刷新，请及时领取</p>
                    <p>最终解释权归益美科技所有</p>
                </div>
            </div>

            {/* 领取确认弹窗 */}
            {showRedeemModal && currentRight && (
                <div className="modal-overlay" onClick={() => setShowRedeemModal(false)}>
                    <div className="redeem-modal" onClick={e => e.stopPropagation()}>
                        <div className="modal-icon">{currentRight.icon}</div>
                        <h3 className="modal-title">确认领取 {currentRight.title}?</h3>
                        <p className="modal-desc">权益领取后不可退换，请确认账号无误</p>
                        
                        {currentRight.type === 'video' && (
                            <div className="platform-grid">
                                {currentRight.platforms.map(p => (
                                    <div 
                                        key={p} 
                                        className={`platform-option ${selectedPlatform === p ? 'selected' : ''}`}
                                        onClick={() => setSelectedPlatform(p)}
                                    >
                                        <span className="platform-name">{p}</span>
                                    </div>
                                ))}
                            </div>
                        )}

                        <button className="modal-confirm-btn" onClick={confirmRedeem}>
                            确认领取
                        </button>
                    </div>
                </div>
            )}

            {/* 成功弹窗 */}
            {showSuccessModal && (
                <div className="modal-overlay">
                     <div className="redeem-modal">
                        <div className="success-checkmark">
                            <svg className="check-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                                <circle className="check-circle" cx="26" cy="26" r="25" fill="none"/>
                                <path className="check-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                            </svg>
                        </div>
                        <h3 className="modal-title">领取成功！</h3>
                        <p className="modal-desc">权益通常在1-3分钟内到账<br/>请留意短信通知</p>
                        <button className="modal-confirm-btn" onClick={() => setShowSuccessModal(false)}>
                            知道了
                        </button>
                     </div>
                </div>
            )}
        </div>
    );
};

export default MemberRightsPage;